import Api from "../services/api/index";

export default function configureDeps() {
  const api = new Api();
  return { api };
}
